import { Organization } from '@/models/Organization';
import { Status } from '@/models/Status';

export enum RetailerAssociation {
  ORGANIZATION = 'organization',
}

export interface Retailer {
  id: string;
  organizationId: string;
  name: string;
  email: string;
  currencyCode: string;
  status: Status;
  externalCode?: string;
  customerCode?: string;
  organization?: Organization;
  createdAt: Date;
}

export interface RetailerCreate {
  organizationId: string;
  name: string;
  email: string;
  currencyCode: string;
  status: Status;
  externalCode?: string;
}

export interface RetailerUpdate {
  id: string;
  organizationId: string;
  name: string;
  email: string;
  currencyCode: string;
  status: Status;
  externalCode?: string;
}

export interface Retailers {
  items: Retailer[];
  totalCount?: number;
  estimatedTotalCount?: number;
}
